<template>
  <div class="chapterRecord">
    <common-breadcrumb/>
    <div class="main-container">
      <div class="main-title clearfix">
        <div class="fl main-title-left">
          您一共完成{{ examCount }}次考试，
          平均分为：{{ averageScore }}分，继续努力吧！
          您做题正确率为：<span>{{ accuracy }}%</span>
        </div>
        <div class="fr main-title-right">排序：
          <el-select v-model="orderValue" @change="changeOrder()" size="small">
            <el-option v-for="(item, idx) in orderOptions" :key="idx" :value="item.value" :label="item.label"/>
          </el-select>
        </div>
      </div>
      <div class="main-table">
        <el-table :data="recordList" row-class-name="spHeight" :row-style="{height:'53px'}" stripe>
          <el-table-column prop="examName" label="练习记录" width="200" align="left" :show-overflow-tooltip="true"/>
          <el-table-column prop="createTime" label="练习时间" min-width="200" align="center" :show-overflow-tooltip="true"/>
          <el-table-column prop="spendTime" label="用时" width="80" align="center" :show-overflow-tooltip="true"/>
          <el-table-column prop="errorQuesNum" label="错题数" width="80" align="center" :show-overflow-tooltip="true"/>
          <el-table-column prop="lastScore" label="得分" width="80" align="center" class-name="score"
                           :show-overflow-tooltip="true"/>
          <el-table-column label="操作" min-width="270" align="center">
            <template slot-scope="scope">
              <el-button size="mini" @click="parseQuestion(scope.row)">解析</el-button>
              <el-button size="mini" type="Success" @click="retryQuestion(scope.row.bizID)">重做</el-button>
              <el-button size="mini" type="danger" @click="deleteReport(scope.row.bizID)">删除记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="recordsParams.pageNum"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="recordsCount"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { CommonBreadcrumb } from '@components/common/'
  import { getRecordList, quesAnalyStatistics, deleteRecord } from '@api'
  import { timestampToTime, secondsToMinutes, getCookie, LoadingOptions } from "@/utils"


  export default {
    name: 'chapterRecord',
    components: {
      CommonBreadcrumb
    },
    data() {
      return {
        statisticsList: {},               //  考试综合统计数据
        recordsParams: {},                //  记录接口参数
        recordList: [],                   //  考试记录数据列表
        recordsCount: 0,                  //  记录个数
        orderValue: 'createTime,desc',    //  排序选项
        orderOptions: [
          { value: "createTime,desc", label: "时间倒序" },
          { value: "createTime,asc", label: "时间升序" },
          { value: "lastScore,desc", label: "分数倒序" },
          { value: "lastScore,asc", label: "分数升序" }
        ],
        pageSize: 10,                     //  页长
        totalPageNum: 1,                  //  总页数
        courseID: '',                     //
        siteCourseID: '',                 //
        courseName: 'mid',                 //
        flag: '',                          //
        loadingInstance: null
      }
    },
    mounted() {
      this.initData()
      this.getRecordListFun()
      this.getStatisticsList()

    },
    computed: {
      // 获取考试次数
      examCount() {
        return this.statisticsList.total || 0
      },
      // 获取平均分
      averageScore() {
        let result = this.statisticsList.sumScore / this.statisticsList.total || 0
        return Math.round(result * 100) / 100
      },
      // 获取做题正确率
      accuracy() {
        let result =
            this.statisticsList.sumRightNum / this.statisticsList.sumQuesNum || 0
        return Math.round(result * 10000) / 100
      }
    },
    methods: {
      // 初始化数据
      initData() {
        let query = this.$route.query
        const { flag } = this.$route.params
        this.flag = flag === 'paidExam' ? '' : flag
        this.courseID = Number(query.courseID)
        this.siteCourseID = Number(query.siteCourseID)

        this.recordsParams = {
          flag: this.flag,
          userID: Number(getCookie('cdeluid')) || null,
          pageNum: 1,
          pageSize: 7,
          orderType: 'desc',
          orderField: 'createTime',
          courseID: this.courseID,
          bizType: 1
        }
      },
      //  列表排序
      changeOrder() {
        let arr = this.orderValue.split(',')
        this.recordsParams.orderField = arr[0]
        this.recordsParams.orderType = arr[1]
        this.getRecordListFun(this.recordsParams)
      },
      //  获取练习记录列表
      getRecordListFun(flag) {
        if(flag) this.recordsParams.pageNum = 1
        this.loadingInstance = this.$loading(LoadingOptions)
        getRecordList(this.recordsParams).then(res => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })
          res.rows.forEach(val => {
            val.createTime = timestampToTime(val.createTime)
            val.spendTime = secondsToMinutes(val.spendTime)
          })
          this.recordList = res.rows || []
          this.recordsCount = res.total || 0
          this.pageSize = res.pageSize || 10
          this.totalPageNum = res.totalPageNum || 1
        })
      },
      // 查看用户统计数据
      getStatisticsList() {
        let dataParams = {
          flag: this.flag,
          userID: Number(getCookie('cdeluid')) || null,
          courseID: this.courseID,
          bizType: 1,
          source: 'pc'
        }
        this.loadingInstance = this.$loading(LoadingOptions)
        quesAnalyStatistics(dataParams).then(res => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })
          this.statisticsList = res
        })
      },
      // 处理页码改变
      async handleCurrentChange(val) {
        this.recordsParams.pageNum = val
        this.getRecordListFun()
      },
      //  重做试题
      retryQuestion(bizID) {
        const { flag } = this.$route.params
        this.$router.push({
          name: 'doExamChapter',
          query: {
            flag: flag,
            bizID: bizID,
            siteCourseID: this.siteCourseID,
            courseID: this.courseID,
            paperRedo: '1'
            // temp: '1'
          }
        })
      },
      // 解析试题
      parseQuestion(row) {
        const { flag } = this.$route.params
        // this.$router.push({
        //   name: 'analysis',
        //   query: {
        //     flag: flag,
        //     bizID: bizID,
        //     siteCourseID: this.siteCourseID,
        //     courseID: this.courseID
        //   }
        // })
        window.location.href = '//member.chinaacc.com/qzs/index.html#/analysis/examinationViewReport?isExamina=1&jkFlag='+
          this.$categoryInfo.majorTag + '&siteCourseID=' + this.siteCourseID + '&courseID=' + 
          row.courseID + '&paperViewID=-1&bizID=' + row.bizID + '&flag=' + flag
      },
      // 删除考试记录
      deleteReport(bizID) {
        let deleteParams = {
          bizID: bizID,
          flag: this.flag,
          source: 'pc'
        }
        this.$confirm('此操作将永久删除该次考试, 是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loadingInstance = this.$loading(LoadingOptions)
          deleteRecord(deleteParams).then(() => {
            this.$nextTick(() => {
              this.loadingInstance.close()
            })
            this.$message.success('删除成功')
            this.getRecordListFun(true)
            this.getStatisticsList()
          })
        })
      }
    }
  }
</script>
<style lang="scss">
  .chapterRecord {
    .main-container {
      margin-top: 20px;
      background-color: #ffffff;
      height: 500px;
      overflow: hidden;

      .main-title {
        overflow: hidden;
        padding-left: 20px;
        height: 39px;
        font-size: 12px;
        line-height: 40px;
        background-color: #ffffff;
        border-bottom: 1px solid #e6e6e6;

        .main-title-left {
          span {
            color: #fd3b06;
          }
        }

        .main-title-right {
          .el-select {
            margin-right: 34px;
            width: 100px;

            .el-input--suffix {
              .el-input__inner {
                padding: 0 15px;
              }
            }
          }

          .el-input--suffix {
            .el-input__inner {
              padding: 0 15px;
            }
          }

          .app-container input {
            padding: 0 15px;
          }
        }
      }

      .main-table {
        margin: 0 auto;
        font-size: 14px;

        .el-table {
          height: 416px;

          .el-table__header,
          .el-table__body {
            margin: 0 auto;
          }

          .spHeight {
            td {
              height: 53px !important;

              .cell {
                max-height: 28px;
                // line-height: 28px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
        }

        .score {
          color: green;

          &:first-child {
            color: green;
          }
        }

        .el-pagination {
          background-color: #ffffff;
          margin-left: 20px;
        }
      }
    }

    .user-defined-style {
      top: 300px !important;
    }
  }
</style>
